import { Email } from './types';

export const initialEmail: Email = {
  to: null,
  cc: null,
  bcc: null,
  subject: null,
  body: null,
};
